import { Col, Modal } from 'antd';
import React from 'react';
import { ReactComponent as RoundTickIcon } from '../../../assets/images/svg/green_tick_icon.svg';
import { setParticipantCreated, setShowOtpScreen } from '../../../store/actions/nhcxAction';
import { useDispatch } from 'react-redux';
const NhcxSuccessModal = ({ showSuccessModal, setShowSuccessModal }: any): any => {
  const dispatch = useDispatch();
  const close = (): any => {
    setShowSuccessModal(false);
    dispatch(setShowOtpScreen(false));
    dispatch(setParticipantCreated(true));
  };
  return (
    <Modal
      visible={showSuccessModal}
      footer={null}
      centered={true}
      onCancel={close}
      maskClosable={true}
      closable={false}
      width={300}
      className="nhcx-modal-content"
    >
      <Col className="fill-success icon-centre tick-icon">
        {<RoundTickIcon />}
      </Col>
      <Col>
        <p className="text-center success-text">
          {'Participation Created Successfully'}
        </p>
      </Col>
    </Modal>);

};

export default NhcxSuccessModal;
